import * as React from "react";
const CaretRight = ({color = "#E5637F"}) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <g mask="url(#mask0_2438_10786)">
      <path
        d="M14.475 12.8125L7.12499 5.4625C6.87499 5.2125 6.75415 4.91667 6.76249 4.575C6.77082 4.23333 6.89999 3.9375 7.14999 3.6875C7.39999 3.4375 7.69582 3.3125 8.03749 3.3125C8.37915 3.3125 8.67499 3.4375 8.92499 3.6875L16.6 11.3875C16.8 11.5875 16.95 11.8125 17.05 12.0625C17.15 12.3125 17.2 12.5625 17.2 12.8125C17.2 13.0625 17.15 13.3125 17.05 13.5625C16.95 13.8125 16.8 14.0375 16.6 14.2375L8.89999 21.9375C8.64999 22.1875 8.35832 22.3083 8.02499 22.3C7.69165 22.2917 7.39999 22.1625 7.14999 21.9125C6.89999 21.6625 6.77499 21.3667 6.77499 21.025C6.77499 20.6833 6.89999 20.3875 7.14999 20.1375L14.475 12.8125Z"
        fill={color}
      />
    </g>
  </svg>
);
export default CaretRight;
